import { omniAtom } from "src/utils/atoms";

import { User } from "./types";

export const userAtom = omniAtom({
	key: "user",
	value: null as User | null,
});
